import { findOrgByUid } from './find-org-by-uid';

type PickableOrg = { uid: string; name: string; opCompany: { uid: string } };

/**
 * Picks the effective org under URL-based org switching. Priority order — keep in lock-step with
 * OrgSwitcherDirective's "My Organization" grouping (page-wrapper/org-switcher/org-switcher.directive.ts)
 * so the default matches the top of the switcher menu:
 *   1. explicit URL uid (user-picked or deep-link)
 *   2. first org (by name) whose opCompany.uid matches the user's home operating company
 *   3. first org (by name) — external-only case
 *   4. null — zero orgs, routing goes to /no-role
 *
 * Expects `orgs` sorted by name (sortOrgsByName), as the org switcher lists them.
 */
export function pickEffectiveOrg<T extends PickableOrg>(
    orgs: readonly T[],
    urlUid: string | null | undefined,
    homeOpCompanyUid: string | null | undefined,
): T | null {
    return (
        findOrgByUid(orgs, urlUid) ??
        (homeOpCompanyUid ? orgs.find(o => o.opCompany.uid === homeOpCompanyUid) : undefined) ??
        orgs[0] ??
        null
    );
}
